import add from './add';
import remove from './remove';
import update from './update';
import copy from './copy';
import paste from './paste';
import pasteHere from './pasteHere';
import zoomIn from './zoomIn';
import zoomOut from './zoomOut';

export * from './CommandManager';
export * from './base';
export * from './redo';
export * from './undo';
export * from './add';
export * from './remove';
export * from './update';
export * from './copy';
export * from './paste';
export * from './pasteHere';
export * from './zoomIn';
export * from './zoomOut';

export const baseCommands = {
  add,
  remove,
  update,
  copy,
  paste,
  pasteHere,
  zoomIn,
  zoomOut,
};

export default baseCommands;
